import { useEffect, useState } from 'react';
import ComboBoxFormik from '../../../../../common/components/form/ComboBoxFormik';
import { createDebounce } from '../../../../../common/helpers/debounce.helper';
import { getPeriods, Period } from '../../../../../common/services/plans.api';

const getPeriodDebounced = createDebounce(getPeriods, 100);

interface AvailablePeriodsProps {
  onChange: (selectedPeriod) => void;
  action?: string;
}

export function AvailablePeriods({ onChange, action }: AvailablePeriodsProps) {

  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  

  const loadOptions = async () => {
    const result = await getPeriodDebounced() as { ok: boolean, data: Period[] };
    let availablePlans = result.data.filter((item) => !item.label.toLowerCase().includes('moto'));

    if (action === "changePlan") {
      //adicionar plano com "moto" a availavlePlans
      const plansMotoclub = result.data.filter((item) => item.label.toLowerCase().includes('+7'));
      availablePlans = [...availablePlans, ...plansMotoclub];
    }
    if (result.ok) {
      setOptions([
        { label: 'Selecione', value: '' },
        ...availablePlans.map((item) => ({ label: item.label, value: item.label }))
      ]);
    } else {
      setOptions([{ label: 'Selecione', value: '' }]);
    }
  };


  useEffect(() => {
    loadOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value: unknown) => {
    onChange(value);
  };

  return (
    <ComboBoxFormik
      name="plan"
      label="Plano:"
      options={options}
      required
      onChange={handleChange}
    />
  );
}
